import { render, staticRenderFns } from "./ModalPartita.vue?vue&type=template&id=1d151f60"
import script from "./ModalPartita.vue?vue&type=script&lang=js"
export * from "./ModalPartita.vue?vue&type=script&lang=js"
import style0 from "./ModalPartita.vue?vue&type=style&index=0&id=1d151f60&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports